import { ApolloCache, Reference } from "@apollo/client"
import { COUNTRY_FRAGMENT } from "../fragment/country"

export const updateCacheCountry = ({
  cache,
  entryData,
  action,
}: {
  cache: ApolloCache<any>
  entryData: any
  action: "update" | "delete" | "add"
}) => {
  return cache.modify({
    fields: {
      countries(existing = []) {
        const newCountryRef = cache.writeFragment({
          data: entryData,
          fragment: COUNTRY_FRAGMENT,
        })
        switch (action) {
          case "add":
            return [...existing, newCountryRef]
          case "delete":
            return [
              ...existing?.filter(
                (el: Reference | undefined) =>
                  el?.__ref !== newCountryRef?.__ref,
              ),
            ]
          case "update":
            const index = existing.findIndex(
              (el: Reference | undefined) => el?.__ref !== newCountryRef?.__ref,
            )
            const items = [...existing]
            if (index > -1) {
              items[index] = newCountryRef
            }
            return items
        }
      },
      aggregateCountry(existing = {}) {
        let _all = existing?._count?.id
        switch (action) {
          case "add":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all + 1 : 0,
              },
            }
          case "delete":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all - 1 : 0,
              },
            }
        }
      },
    },
  })
}
